export { IonWrapperComponent } from './ion-wrapper';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/ion-wrapper/index.ts